import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../helpers';
import { store } from '../../../store/store';
import { AppContextProvider } from '../../../Services/AppContext';
import FirstLoginWizard from './FirstLoginWizard';

loadDOMComponent({
	selector: 'react-first-login-wizard',
	callback: ({ container, context, props }) => {
		const userId = container.getAttribute('data-userId');

		if (!userId) {
			return;
		}

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<FirstLoginWizard userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
